import { z } from 'zod';

export const publicProfileDataSchema = z.object({
  profile: z.object({
    displayName: z.string(),
    username: z.string(),
    bio: z.string(),
    avatarUrl: z.string().nullable(),
    instagramUrl: z.string().nullable(),
  }),
  links: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      iconType: z.string(),
      iconValue: z.string().nullable(),
      thumbnailUrl: z.string().nullable(),
      position: z.number(),
    }),
  ),
  appearance: z.object({
    backgroundType: z.enum(['solid', 'gradient', 'image']),
    backgroundValue: z.string(),
    textColor: z.string(),
    buttonStyle: z.enum(['filled', 'outline', 'soft', 'shadow']),
    buttonRadius: z.enum(['square', 'rounded', 'pill']),
    buttonBackground: z.string(),
    buttonTextColor: z.string(),
    fontFamily: z.string(),
  }),
  layout: z.unknown().optional(),
});

export type PublicProfileData = z.infer<typeof publicProfileDataSchema>;
